import axios from "axios";
import { SUPPLEMENT_BASE_URL } from "src/redux/api/appConst";

export const uploadToGallery = async ({
  s3_key,
  description,
}: {
  s3_key: string;
  description: string;
}) => {
  const { data } = await axios.post(`${SUPPLEMENT_BASE_URL}/gallery`, {
    s3_key,
    description,
  });

  return data;
};

export const fetchGalleryImages = async () => {
  const { data } = await axios.get(`${SUPPLEMENT_BASE_URL}/gallery?limit=30`);

  return data?.data.data;
};

export const deleteImageFromGallery = async (
  photo_id: string,
  created_at: string,
  s3_key: string,
) => {
  const { data } = await axios.delete(`${SUPPLEMENT_BASE_URL}/gallery/photo`, {
    data: {
      photo_id,
      created_at,
      s3_key,
    },
  });

  return data;
};
